import {
	type Field,
	type InactiveFieldLayoutItem,
	type ActiveFieldLayoutItem,
	type AssociatedField,
	FIELD_LAYOUT_ITEM_TYPE,
	toLayoutItemKey,
} from '../../types/layout-items';

export const getLayoutItemFromAssociatedField = (
	field: AssociatedField,
): ActiveFieldLayoutItem => ({
	key: toLayoutItemKey(FIELD_LAYOUT_ITEM_TYPE, field.key),
	layoutItemType: FIELD_LAYOUT_ITEM_TYPE,
	data: field,
	operations: field.operations,
	category: field.category,
});

export const getLayoutItemFromField = (field: Field): InactiveFieldLayoutItem => ({
	key: toLayoutItemKey(FIELD_LAYOUT_ITEM_TYPE, field.key),
	layoutItemType: FIELD_LAYOUT_ITEM_TYPE,
	data: field,
	operations: field.operations,
	category: null,
});
